import React from 'react';
import PropTypes from 'prop-types';

import ConfirmCheckoutDate from './ConfirmCheckoutDate';

const ConfirmCheckoutHeader = ({ confirm, showTime = true, entryTimeLabel = null, seriesReturnUrl = null }) => {
  if (!confirm) return null;

  return (
    <div>
      <p className="mb-1 mt-1 text-dark" style={{ fontSize: "24px" }}>
        <strong>{confirm.title}</strong>
      </p>
      {confirm.support_artist_names && confirm.support_artist_names.length > 0 ? (
        <p className="mb-1" style={{ fontSize: "16px", color: "var(--widget-secondary-text-color, #686868)" }}>
          with {confirm.support_artist_names}
        </p>
      ) : null}
      {confirm.age_restriction ? (
        <p className="mb-1" style={{ fontSize: "16px", color: "var(--widget-secondary-text-color, #686868)" }}>
          {confirm.age_restriction}
        </p>
      ) : null}
      <ConfirmCheckoutDate confirm={confirm} showTime={showTime} entryTimeLabel={entryTimeLabel} />
      {seriesReturnUrl ? (
        <p className="mb-1">
          <a href={seriesReturnUrl} style={{ fontSize: "14px" }}>
            &lsaquo; Change date &amp; time
          </a>
        </p>
      ) : null}
      {confirm.venue && confirm.venue.has_non_country_address_info ? (
        <p className="mb-1" style={{ color: "var(--widget-secondary-text-color, #686868)" }}>
          {confirm.venue.address_from_components}
        </p>
      ) : null}
      {confirm.venue && confirm.venue.location_notice ? (
        <p className="mb-1" style={{ color: "var(--widget-secondary-text-color, #686868)", fontSize: "14px" }}>
          {confirm.venue.location_notice}
        </p>
      ) : null}
    </div>
  );
};

ConfirmCheckoutHeader.propTypes = {
  confirm: PropTypes.object,
  showTime: PropTypes.bool,
  entryTimeLabel: PropTypes.string,
  seriesReturnUrl: PropTypes.string
};

export default ConfirmCheckoutHeader;
